<!--
 * @Description: 设备役龄占比
 * @Autor: xiaona.wang
 * @Date: 2021-12-14 20:56:34
 * @LastEditors: yingna.gao
 * @LastEditTime: 2022-07-06 18:49:15
-->
<template>
  <div class="chart-wrapper">
    <div class="tab_wrap">
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'NEARLY' }" @click="buttonClick('NEARLY')">近30天</span>
      <span class="tab_button" :class="{ bgColor: timeFilterType === 'CURRENT_MONTH' }" @click="buttonClick('CURRENT_MONTH')">本月</span>
    </div>
    <div id="device_workingAge_rate" class="box_conetnt"/>
  </div>
</template>

<script>
import * as echarts from "echarts";
require("echarts/theme/macarons"); // echarts theme
import cockpitApi from "@/api/cockpit/cockpit";
import resize from "./mixins/resize";

export default {
  name: "DeviceWorkingAgeRate",
  mixins: [resize],
  data() {
    return {
      chart: null,
      timeFilterType: "NEARLY"
    };
  },
  mounted() {
    this.$nextTick(() => {
      this.getDeviceWorkingAgeRate();
    });
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  methods: {
    resizeSetData() {
      setTimeout(() => {
        this.chart && this.chart.resize();
      }, 200);
    },
    buttonClick(type) {
      this.timeFilterType = type;
      this.getDeviceWorkingAgeRate(type);
    },
    // 获取接口数据
    getDeviceWorkingAgeRate(type = "NEARLY") {
      cockpitApi.getDeviceWorkingAgeRate({ searchType: type }).then(result => {
        if (result.code === 200 && result.success) {
          const echartsData = [];
          let total = 0;
          result.data.map(item => {
            const temp = {};
            temp.name = item.yearName;
            temp.value = Number(item.yearValue);
            total += Number(item.yearValue);
            echartsData.push(temp);
          });
          this.drawDeviceWorkingAgeRate(total, echartsData);
        }
      });
    },
    // echarts 设备役龄占比
    drawDeviceWorkingAgeRate(total = "0", echartsData = []) {
      this.chart = echarts.init(document.getElementById("device_workingAge_rate"));
      this.chart.setOption({
        // graphic: {
        //   type: "text",
        //   left: "43%",
        //   top: "43%",
        //   style: {
        //     //数据总量
        //     text: "总量\n" + total,
        //     textAlign: "left",
        //     fill: "black",
        //     fontSize: 14,
        //   },
        // },

        graphic: [
          {
            type: "group",
            left: "44%",
            top: "41%",
            width: 100,
            height: 100,
            children: [
              {
                type: "text",
                z: 100,
                left: "center",
                top: "85%",
                style: {
                  text: "总量",
                  textAlign: "center",
                  fill: "#999999"
                }
              },
              {
                type: "text",
                z: 100,
                left: "center",
                top: "100%",
                style: {
                  text: total,
                  textAlign: "center",
                  fill: "#000",
                  fontSize: 12
                }
              }
            ]
          }
        ],
        title: {
          text: "设备役龄占比",
          align: "right"
        },
        color: ["#668AFF", "#0DDFB7", "#FBC12E", "#3BAAFF", "#7F59F0", "#D4D9E2"],
        tooltip: {
          trigger: "item",
          formatter: "{a} <br/>{b}: {c} ({d}%)"
        },
        legend: {
          icon: "circle",
          bottom: "20",
          itemHeight: 8,
          itemWidth: 8
        },
        series: [
          {
            name: "设备役龄占比",
            type: "pie",
            radius: ["25%", "45%"],
            center: ["50%", "50%"], // 图的位置，距离左跟上的位置
            avoidLabelOverlap: false,
            label: {
              normal: {
                show: true, // 展示
                position: "outside", // outside表示文本显示位置为外部
                formatter: "{b}\n({d}%)"
              },
              emphasis: {
                // 文本样式
                show: true, // 展示
                textStyle: {
                  // 文本样式
                  fontSize: "14",
                  fontWeight: "600"
                }
              }
            },
            labelLine: {
              show: true
            },
            data: echartsData
          }
        ]
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.chart-wrapper{
  width:100%;
  height:100%;
  padding:24px 24px 16px;
}
.box_conetnt{
  width:100%;
  height:100%;
}
.tab_wrap {
  position: absolute;
  text-align: center;
  color: #5b5b5c;
  right: 36px;
  top: 16px;
  z-index: 99;
  .tab_button {
    display: inline-block;
    width: 80px;
    height: 28px;
    line-height: 28px;
    background-color: #f5f7fa;
    color: #505363;
  }
  .bgColor {
    background-color: #00b259;
    color: #fff;
  }
}
</style>
